import { render, staticRenderFns } from "./exchange.pug?vue&type=template&id=43566e2d&scoped=true&lang=pug&external"
import script from "./exchange.js?vue&type=script&lang=js&external"
export * from "./exchange.js?vue&type=script&lang=js&external"
import style0 from "./exchange.vue?vue&type=style&index=0&id=43566e2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43566e2d",
  null
  
)

export default component.exports